import { Header } from './components/header'
import { ThemeProvider, useTheme } from '@material-ui/core';
import { Theme } from './context/theme/provider'
import { Footer } from './components/footer'
import { Content } from './components/content'

function App() {
  return (
    <div className="App" style={{height: '100vh', display: 'flex', flexDirection: 'column'}}>
      <ThemeProvider theme={Theme}>
        <Header/>
        <Content />
        <Footer />
      </ThemeProvider>
    </div>
  );
}

export default App;
